import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";

import type { RootState } from "../redux/reducers/session/state";

const Redirect = ({ authRedirect, unAuthRoute }: { authRedirect: string; unAuthRoute: string }) => {
  const token = useSelector((state: RootState) => state.sessionState.token);
  if (token) return <Navigate to={authRedirect} replace={true} />;
  if (!token) return <Navigate to={unAuthRoute} replace={true} />;
};

export default Redirect;
